import { ActivityType } from '../../../../../../../data-access/gql-types/graphql';
import { ParametersType } from './parameters-type';

export const useOnOffControl = (channelParameters: ParametersType) => {
  const removedChannelParameters = (param: ActivityType) => {
    const newChannelParameters = { ...channelParameters };
    delete newChannelParameters[param];
    return newChannelParameters;
  };

  const setOn = () => {
    const newChannelParameters = removedChannelParameters(ActivityType.Off);

    newChannelParameters[ActivityType.On] = { activityType: ActivityType.On, value: '' };
    return newChannelParameters;
  };

  const setOff = () => {
    const newChannelParameters = removedChannelParameters(ActivityType.On);

    newChannelParameters[ActivityType.Off] = { activityType: ActivityType.Off, value: '' };
    return newChannelParameters;
  };

  return { setOn, setOff };
};
